import React from 'react';
import { Box, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Wrapper } from '../Halls/List/styles';
import HallBox from '../Tables/List/hall-box';
import { hallSelector } from '../../redux/hallReducer';
import { useSelector } from 'react-redux';
import Preloader from '../Common/Preloader';
import { isConfirmType } from '../../interfaces';
import { getJackpotErrors, useFindJackpotsQuery, useDeleteJackpotMutation } from '../../api/jackpot';
import JackpotError from './error';
import CurrentTable from './current-table';
import TableJackpots from './table-jackpots';
import { Link } from "react-router-dom";
import Overlay from '../Common/Overlay/index';
import Jackpot from './View';
import Confirm from '../Common/Confirm';
import AddJackpot from './Add';
import { authSelector } from '../../redux/authReducer';
import { findPermission } from '../../utils/find';

interface CurrentJackpotsProps {
    isModal?: boolean;
    hallId: number;
    setHallId: (hallId: number) => void;
}

const CurrentJackpots: React.FC<CurrentJackpotsProps> = React.memo(({ isModal, hallId, setHallId }) => {
    const [t] = useTranslation();
    const [jackpotId, setJackpotId] = React.useState<number>(0);
    const [isAddJackpot, setIsAddJackpot] = React.useState(false);
    const { assigments: { items: permissions } } = useSelector(authSelector);
    const { halls: { data: halls } } = useSelector(hallSelector);
    const { currentData: result, isFetching: loading, error: loadError } = useFindJackpotsQuery(
        { status: [0, 1], halls: [hallId], perPage: 4 }, { skip: !hallId }
    );
    const [deleteJackpot, { isLoading: deleting, error, reset }] = useDeleteJackpotMutation();
    React.useEffect(() => {
        if (!hallId && halls.length) {
            setHallId(halls[0].id);
        }
    }, [halls, hallId, setHallId]);
    const [isConfirm, setIsConfirm] = React.useState<isConfirmType>({ open: false });
    const deleteJackpotConfirm = (id: number, name: string) => { reset(); setIsConfirm({ id, name, open: true }); };
    const deleteJackpotStart = async (id?: number) => {
        if (!id) return;
        try {
            await deleteJackpot(id).unwrap();
            setIsConfirm({ open: false });
        } catch { /* Keep the confirmation open and display the error. */ }
    };
    //Jackpot::STATUS_ACTIVE, Jackpot::STATUS_ACCUMULATION_ONLY, Jackpot::STATUS_PAUSED, Jackpot::STATUS_COMPLETED
    return <Wrapper isModal={isModal}>
        <Box style={{ minWidth: '968px' }}>
            {!isModal && <Box display="flex" justifyContent="space-between" alignItems="center">
                <h2>{t('ru.jackpots.title')} <Link to="/jackpots/history"><Button variant="contained" color="primary" size="small">посмотреть завершённые</Button></Link></h2>
                {findPermission(permissions, 'jackpotCreate') && <Button variant="contained" color="primary" disabled={!hallId} onClick={() => setIsAddJackpot(true)}>
                    {t('ru.jackpots.add_form')}
                </Button>}
            </Box>}
            {hallId > 0 && <div style={{ position: 'relative' }}>
                <JackpotError error={loadError} />
                <JackpotError error={error} />
                <HallBox hallId={hallId} setHallId={setHallId} halls={halls} />
                {loading ? <Preloader /> : <CurrentTable jackpots={result?.items || []} hall_id={hallId} setJackpotId={setJackpotId} deleteJackpot={deleteJackpotConfirm} />}
                <TableJackpots hallId={hallId} setJackpotId={setJackpotId} deleteJackpot={deleteJackpotConfirm} />
            </div>}
            {jackpotId > 0 && <Overlay>
                <Jackpot table_id={null} hall_id={hallId} isChangeMode={false} jackpotId={jackpotId} hideJackpot={() => setJackpotId(0)} />
            </Overlay>}
            {isAddJackpot && <Overlay>
                <AddJackpot hall_id={hallId} hideAddJackpot={() => setIsAddJackpot(false)} />
            </Overlay>}
            {isConfirm.open && <Overlay>
                <Confirm text={`${t('ru.common.confirm.delete')} ${isConfirm.name}? ${getJackpotErrors(error).map(item => item.message).join('; ')}`} loading={deleting} cancel={() => { reset(); setIsConfirm({ open: false }); }} submit={() => deleteJackpotStart(isConfirm.id)} />
            </Overlay>}
        </Box>
    </Wrapper>;
});

export default CurrentJackpots;
